import { FileTextOutlined } from "@ant-design/icons";
import { Button, Space, Table, Typography } from "antd";
import moment from "moment-timezone";
import { MetricsRequest, usePullerMetrics, useShipperMetrics } from "pages/staff/useMetrics";

const { Text } = Typography;

const timeSpanRender = (timespan: string | null) => {
    if (!timespan) {
        return null;
    }

    const duration = moment.duration(timespan);
    const tmp = moment.utc(duration.asMilliseconds());

    if (duration.hours() >= 1) {
        return tmp.format("h[h] m[m] s[s]");
    }

    return tmp.format("m[m] s[s]");
}

const TableHeader = ({ text, onCsvExport, exportDisabled }: { text: string, onCsvExport: () => Promise<void>, exportDisabled: boolean }) => {
    return <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Text strong>
            {text}
        </Text>
        <Button
            type="link" icon={<FileTextOutlined />}
            onClick={onCsvExport}
            disabled={exportDisabled}
        >
            Export To CSV
        </Button>
    </Space>
};

export const PullerTable = (request: MetricsRequest) => {
    const { data = [], isLoading, csvExport } = usePullerMetrics(request);

    return <>
        <TableHeader
            text="Times shown represent the user's average per 100 cards for singles, and per 300 cards for heavy & regular bulks."
            onCsvExport={csvExport}
            exportDisabled={data.length === 0}
        />
        <Table
            style={{ marginTop: '10px' }}
            loading={isLoading}
            columns={[
                { title: "User", dataIndex: "userName", },
                { title: "Singles", dataIndex: "singlesAvgPullTime", render: timeSpanRender },
                { title: "Heavy Bulks", dataIndex: "heavyBulksAvgPullTime", render: timeSpanRender },
                { title: "Regular Bulks", dataIndex: "regularBulksAvgPullTime", render: timeSpanRender }
            ]}
            rowKey={m => m.userId}
            dataSource={data}
            pagination={false}
        />
    </>
}

export const ShipperTable = (request: MetricsRequest) => {
    const { data = [], isLoading, csvExport } = useShipperMetrics(request);

    return <>
        <TableHeader
            text=" Times shown represent the user's average per individual shipment"
            onCsvExport={csvExport}
            exportDisabled={data.length === 0}
        />
        <Table
            style={{ marginTop: '10px' }}
            loading={isLoading}
            columns={[
                { title: "User", dataIndex: "userName", },
                { title: "Priority Single", dataIndex: "prioritySingleAvgShipTime", render: timeSpanRender },
                { title: "Single Raw", dataIndex: "singleRawAvgShipTime", render: timeSpanRender },
                { title: "Single Raw High$", dataIndex: "singleRawHighDollarAvgShipTime", render: timeSpanRender },
                { title: "Single Graded", dataIndex: "singleGradedAvgShipTime", render: timeSpanRender },
                { title: "Single Graded High$", dataIndex: "singleGradedHighDollarAvgShipTime", render: timeSpanRender },
                { title: "Priority Bulk", dataIndex: "priorityBulkAvgShipTime", render: timeSpanRender },
                { title: "Heavy Bulk 1st Class", dataIndex: "heavyBulkFirstClassAvgShipTime", render: timeSpanRender },
                { title: "Heavy Bulk Priority", dataIndex: "heavyBulkPriorityAvgShipTime", render: timeSpanRender },
                { title: "Regular Bulk", dataIndex: "regularBulkAvgShipTime", render: timeSpanRender },
            ]}
            rowKey={m => m.userId}
            dataSource={data}
            pagination={false}
        />
    </>
}
